import { useQuery } from "@apollo/client/react";
import { useEffect } from 'react'
import useLatest from 'hooks/useLatest'

export default function useDynamicQuery(query, options = null) {
  const q = useQuery(query, {
    ...options,
    notifyOnNetworkStatusChange: true,
  })
  const qRef = useLatest(q)

  const optionsKey = JSON.stringify(options)

  useEffect(() => {
    // q is read via ref rather than being a dependency -- its identity
    // changes on every loading/data transition, including the one caused by
    // calling refetch() below, so depending on it directly would create a
    // refetch loop.
    if (qRef.current && !qRef.current.loading) {
      qRef.current.refetch()
    }
  }, [optionsKey, qRef])

  return q
}
